<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">垃圾桶设备</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="deviceName">
            <el-input
              v-model="deviceName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="RegionId" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in EqRegionArr"
                :key="item.RegionId"
                :label="item.RegionName"
                :value="item.RegionId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <!-- <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div> -->
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="TRASHCODE"
                label="垃圾桶编号"
              ></el-table-column>
              <el-table-column
                prop="TRASHNAME"
                label="垃圾桶名称"
              ></el-table-column>
              <el-table-column prop="TRASHTYPE" label="垃圾桶类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.TRASHTYPE == 1">湿垃圾</span>
                  <span v-else-if="scope.row.TRASHTYPE == 2">干垃圾</span>
                  <span v-else-if="scope.row.TRASHTYPE == 3">有害垃圾</span>
                  <span v-else-if="scope.row.TRASHTYPE == 4">可回收物</span>
                </template>
              </el-table-column>
              <el-table-column prop="TRASHIP" label="IP地址"></el-table-column>
              <el-table-column
                prop="BELONGAREA"
                label="所属区域"
                :formatter="RegionNumToNameConverter"
              >
              </el-table-column>
              <el-table-column prop="TRASHSTATUS" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.TRASHSTATUS == 0" style="color: red"
                    >离线</span
                  >
                  <span v-else-if="scope.row.TRASHSTATUS == 1" style="color: green"
                    >在线</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "SmartTrashManagerView",
  controller: "UI",
  action: "SmartTrashManagerView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      deviceName: "",
      RegionId: "",
      EqRegionArr: [],
      loading: false,
      loadingText: '加载中...',
    };
  },
  created: function () {
    //所属区域
    this.getRegionInfo();
  },
  mounted: function () {
    this.search();
  },
  methods: {
    RegionNumToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const RegionName = this.EqRegionArr.map((item) => {
        if (item.RegionId == data) return item.RegionName;
      }).join("");
      if (RegionName == null || RegionName == "") {
        return data;
      }
      return RegionName;
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let searchInfo = {
        TRASHNAME: this.deviceName,
        BELONGAREA: this.RegionId == "" ? null : this.RegionId,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      this.loading = true;
      new MyApis.TranResourcesApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.ContentList;
          this.total = r.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/smartTrash/UI/SmartTrashManagerInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/smartTrash/ui/SmartTrashManagerInfo",
        query: { InfoId: row.ID, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/smartTrash/ui/SmartTrashManagerInfo",
        query: { InfoId: row.ID, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "删除中...";
          new MyApis.TranResourcesApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.loading = false;
              this.search();
            })
            .catch((e) => {
              this.loading = false;
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.deviceName = "";
      this.RegionId = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
